/* @flow */
import * as React from 'react';
import { isEqual } from 'lodash';

import Group from 'entities/Group';
import GroupMessages from 'groups/components/GroupMessages';
import { markChange } from 'lib/Timer';

type Props = {
  params: Object,
  children: React.Node,
  group: Group,
};

class GroupMessagesContainer extends React.Component<Props> {
  componentDidMount() {
    markChange('to_chats', 'mounted');
  }

  shouldComponentUpdate(nextProps: Object) {
    const groupChanged = !isEqual(this.props.group.attributes, nextProps.group.attributes);
    const routeChanged = !isEqual(this.props.params, nextProps.params);
    return routeChanged || groupChanged;
  }

  render() {
    const { group, children, params } = this.props;

    return (
      <GroupMessages group={group} selectedChatId={params.chatId}>
        {// $FlowIssue Inexact type is incompatible with exact type object
        React.cloneElement(children, { group })}
      </GroupMessages>
    );
  }
}

export default GroupMessagesContainer;
